export default {"src":"/_next/static/media/trusted-partner.74e230aa.svg","height":47,"width":158,"blurWidth":0,"blurHeight":0};